module.exports = __webpack_public_path__ + "static/media/host_flow_model.e3c4e551.svg";